import axios from "axios";

import { RawSession } from "../../types/api/userSession";
import { RawScenarioPerformance } from "../../types/api/scenario";
import { RawRepetitionResponse } from "../../types/api/repetition";
import { RawStabilityPresentation, RawWeaponPresentation } from "../../types/api/drill";
import { RawUserStatistics } from "../../types/api/userStatistics";

const REACT_APP_API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";
const REACT_APP_DATA_API_URL = process.env.REACT_APP_DATA_API_URL || "http://54.157.64.38:8001";

export const getSessions = async (
  limit?: number
): Promise<RawSession[]> => {

  const token = localStorage.getItem('authToken');
  const headers = token ? { Authorization: `Bearer ${token}` } : {};

  try {
    const response = await axios.get<RawSession[]>(
      `${REACT_APP_API_URL}/session/`,
      {
        headers,
        params: limit != null ? { limit } : {},
      }
    );
    return response.data;
  } catch (err) {
    console.error('Error fetching sessions:', err);
    throw new Error('Failed to fetch sessions');
  }
};

export async function getScenarioPerformance(
  userId: number,
  sessionId: number
): Promise<RawScenarioPerformance[]> {

  const res = await axios.get<{
    total_count: number;
    data: RawScenarioPerformance[];
  }>(`${REACT_APP_DATA_API_URL}/metrics/users/${userId}/performance/scenario`, {
    params: { session_id: sessionId },
  });
  return res.data.data;
}


export async function getRepetitionPerformance(
  userId: number,
  sessionId: number,
  scenarioId: number,
  drillName?: string,
  repetitionNumber?: number
): Promise<RawRepetitionResponse> {

  const res = await axios.get<RawRepetitionResponse>(
    `${REACT_APP_DATA_API_URL}/metrics/users/${userId}/performance/repetition`,
    {
      params: {
        session_id: sessionId,
        scenario_id: scenarioId,
        ...(drillName ? { drill: drillName } : {}),
        ...(repetitionNumber != null
          ? { repetition_number: repetitionNumber }
          : {}),
      },
    }
  );

  return res.data;
}


export async function getWeaponPresentation(
  userId: number,
  sessionId: number,
  scenarioId: number,
  drillName: string,
  repetitionNumber?: number
): Promise<RawWeaponPresentation> {


  const res = await axios.get<RawWeaponPresentation>(
    `${REACT_APP_DATA_API_URL}/metrics/users/${userId}/weapon_presentation`,
    {
      params: {
        session_id: sessionId,
        scenario_id: scenarioId,
        drill: drillName,
        ...(repetitionNumber != null
          ? { repetition_number: repetitionNumber }
          : {}),
      },
    }
  );

  return res.data;
}

export async function getStabilityPresentation(
  userId: number,
  sessionId: number,
  scenarioId: number,
  drillName: string,
  repetitionNumber?: number
): Promise<RawStabilityPresentation> {
  const res = await axios.get<RawStabilityPresentation>(
    `${REACT_APP_DATA_API_URL}/metrics/users/${userId}/stability_presentation`,
    {
      params: {
        session_id: sessionId,
        scenario_id: scenarioId,
        drill: drillName,
        ...(repetitionNumber != null
          ? { repetition_number: repetitionNumber }
          : {}),
      },
    }
  );

  return res.data;
}

export async function getUserStatistics(userId: number): Promise<RawUserStatistics> {
  try {
    const res = await axios.get<RawUserStatistics>(
      `${REACT_APP_DATA_API_URL}/metrics/users/${userId}/statistics`
    );
    return res.data;
  } catch (error: any) {
    console.error(`Failed to fetch user statistics for user ${userId}:`, error);
    throw new Error('Failed to load user statistics');
  }
}
